import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios';
import swal from 'sweetalert2';
import { toast } from 'react-toastify';  
const baseURL = process.env.REACT_APP_API_BASE_URL;

const Verify_Checklist = ({ show, onClose, data   , onSuccess}) => {
    const [checkedItems, setCheckedItems] = useState({});

    useEffect(() => {
        if (data?.item_checklist?.length > 0) {
            const init = {};
            data.item_checklist.forEach(item => {
                init[item.id] = item.checklist_status === 0; // 0 = checked
            });
            setCheckedItems(init);
        }
    }, [data]);

    const handleCheckboxChange = (id) => {
        setCheckedItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleChecklistSubmit = () => {
        const payload = {
            item_checklist: data.item_checklist.map(item => ({
                id: item.id,
                quality_name: item.quality_name,
                priority_id: item.priority_id ?? null,
                priority_name: item.priority_name ?? '',
                checklist_status: checkedItems[item.id] ? 0 : 1
            }))
        };

        axios.post(`${baseURL}/work-assignment/update-checklist/${data.sno}`, payload)
            .then(res => {

                toast.success("Wastage Saved Successfully!");
                if (onSuccess) {
                    onSuccess(); // e.g., trigger data refetch or update state
                }
                    onClose(); // Close modal or form
                // swal.fire("✅ Success", "Checklist updated successfully!", "success");
                // onClose();
            })
            .catch(err => {
                console.error("Checklist update failed", err);
                swal.fire("❌ Error", "Something went wrong!", "error");
            });
    };

    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Quality Analysis Checklist</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* Item Image & Info */}
                    <div className="d-flex align-items-center justify-content-start gap-2 mb-5">
                        <LightGallery onInit={() => { }} speed={500} plugins={[lgThumbnail, lgZoom]}>
                            <div data-src={data?.item_info?.image} className='border rounded px-1 py-0'>
                                <img src={data?.item_info?.image} alt={data?.item_info?.name} className='cursor-pointer w-60px h-60px' />
                            </div>
                        </LightGallery>
                        <div>
                            <label className='text-danger font-w600 fs-5'>{data?.item_info?.name}</label>
                            <div className="d-block">
                                <label className="fs-7 text-dark">
                                    {data?.item_info?.category} / {data?.item_info?.sub_category}
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Checklist Table */}
                    <div className="table-container mb-4" style={{
                        maxHeight: data?.item_checklist?.length > 5 ? '250px' : 'auto',
                        overflowY: data?.item_checklist?.length > 5 ? 'auto' : 'visible',
                        border: '1px solid #e4e6ef',
                        borderRadius: '0.5rem'
                    }}>
                        <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable mb-0">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className="min-w-60px text-center">Check</th>
                                    <th className="min-w-180px">Quality Name</th>
                                    <th className="min-w-120px">Priority</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {data?.item_checklist?.length > 0 ? (
                                    data.item_checklist.map((check) => (
                                        <tr key={check.id}>
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={checkedItems[check.id] || false}
                                                    onChange={() => handleCheckboxChange(check.id)}
                                                />
                                            </td>
                                            <td>{check.quality_name}</td>
                                            <td>{check.priority_name}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            No checklist available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-2">
                        <Button variant="primary" className="btn-sm" onClick={handleChecklistSubmit}>
                            Submit Checklist <i className="fas fa-angle-double-right ms-2"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Verify_Checklist;
